module.exports = __webpack_public_path__ + "img/msg_success.683cf573.png";